import { env } from "../../../env";
const axios = require("axios").default;
const URL = `${env.REACT_APP_API_URL}/api/reporting`;
const URL_RDM = `${env.REACT_APP_API_URL}/api/RDM`;
const URL_VEHICLE = `${env.REACT_APP_API_URL}/api/Vehicle`;

export const getAll = (payload) => {
  return axios
    .get(URL, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getUniqueVehicleList = (payload) => {
  return axios
    .get(`${URL_VEHICLE}/Unique`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleInformation = (payload) => {
  return axios
    .get(`${env.REACT_APP_API_URL}/api/inventory/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSingleVehicleInformation = ({vin}) => {
  return axios
    .get(`${env.REACT_APP_API_URL}/api/inventory/search`, {
      params: {
        vin
      },
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getTransactionLogs = (vehicle_id, payload) => {
  return axios
    .get(`${URL_VEHICLE}/VehicleInformation/${vehicle_id}`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleInformationDownload = (payload) => {
  return axios
    .get(`${env.REACT_APP_API_URL}/api/inventory/Download`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleInformationDownloadBlob = (payload) => {
  return axios
    .get(`${URL}/ReportVehicleInformationDownload`, {
      params: payload,
      responseType: "blob",
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getFile = (payload) => {
  return axios
    .get(`${URL}/download`, {
      params: payload,
      // responseType: "blob",
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getFileBlob = (payload) => {
  return axios
    .get(`${URL}/download`, {
      params: payload,
      responseType: "blob",
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getRDM = (payload) => {
  return axios
    .get(URL_RDM, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateRDM = (payload) => {
  return axios.put(`${URL_RDM}/cancel`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
